// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "59164aa0163e";
export const BUILD_VERSION_NUMBER = 78;
